import ClassNames from "classnames";
import UserAgent from "ua-parser-js";
export const cn = ClassNames;
export { createBEM } from "./bem";
export * from "./validator";
export const ua = new UserAgent();
